import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import Paginator from 'jbc-front/components/Paginator'
import Button from 'jbc-front/components/Button'
import { Glass } from 'jbc-front/components/icons'
import CommonModal from 'jbc-front/components/CommonModal'
import styles from 'jbc-front/components/BankSearchModal.scss'

const BankTable = ({ banks, handleSelect }) => (
  <ul className={styles.list}>
    {banks.map(bank => (
      <li role="presentation" key={bank.id} onClick={() => handleSelect(bank)}>
        {bank.bankCode}：{bank.name}
      </li>
    ))}
  </ul>
)

const BranchTable = ({ branches, handleSelect }) => (
  <ul className={styles.list}>
    {branches.map(branch => (
      <li role="presentation" key={branch.id} onClick={() => handleSelect(branch)}>
        {branch.branchCode}：{branch.name}
      </li>
    ))}
  </ul>
)

class BankSearch extends React.Component {
  static propTypes = {
    selectedBank: PropTypes.object,
    banks: PropTypes.array,
    branches: PropTypes.array,
    count: PropTypes.number,
    currentPage: PropTypes.number,
    handleBankSearch: PropTypes.func,
    handleBranchSearch: PropTypes.func,
    onBankSelect: PropTypes.func,
    onReset: PropTypes.func,
    onSelect: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.textbox = null
    this.scrollableArea = null
  }

  componentDidUpdate() {
    this.scrollableArea.scrollTop = 0
  }

  _handleBankSelect = bank => {
    const { onBankSelect } = this.props
    this.clearTextbox()
    onBankSelect(bank)
  }

  _handleBranchSelect = branch => {
    const { onSelect } = this.props
    const { selectedBank } = this.props
    onSelect(selectedBank, branch)
  }

  onInputChange = debounce(() => {
    const { selectedBank, handleBankSearch, handleBranchSearch } = this.props
    this.isBankScreen() ? handleBankSearch(this.textbox.value) : handleBranchSearch(selectedBank, this.textbox.value)
  }, 500)

  isBankScreen() {
    const { selectedBank } = this.props
    return selectedBank === null
  }

  clearTextbox() {
    this.textbox.value = ''
  }

  render() {
    const {
      banks,
      branches,
      count,
      currentPage,
      selectedBank,
      handleBankSearch,
      handleBranchSearch,
      onReset
    } = this.props
    const placeholder = selectedBank ? 'Search by branch name' : 'Search by bank name'

    return (
      <div className={styles.bankSearch}>
        <div
          className={styles.scrollable}
          ref={dom => {
            this.scrollableArea = dom
          }}>
          <div className={styles.search}>
            <div className={styles.inputText}>
              <input
                type="text"
                placeholder={placeholder}
                ref={input => {
                  this.textbox = input
                }}
                onChange={this.onInputChange}
              />
              <span className={styles.icon}>
                <Glass size={16} />
              </span>
            </div>
            <div className={styles.action}>
              {selectedBank && (
                <Button
                  type="button"
                  as="button"
                  primary
                  widthAuto
                  onClick={() => {
                    this.clearTextbox()
                    onReset()
                  }}>
                  Back to bank search
                </Button>
              )}
            </div>
          </div>

          <div className={styles.result}>{count} search results</div>

          {this.isBankScreen() && banks.length > 0 && <BankTable banks={banks} handleSelect={this._handleBankSelect} />}
          {!this.isBankScreen() &&
            branches.length > 0 && <BranchTable branches={branches} handleSelect={this._handleBranchSelect} />}
        </div>

        {count > 0 && (
          <div className={styles.pager}>
            <Paginator
              current={currentPage}
              totalResult={count}
              rowsPerPage={10}
              pageLinks={7}
              onClick={page => {
                this.isBankScreen()
                  ? handleBankSearch(this.textbox.value, page)
                  : handleBranchSearch(selectedBank, this.textbox.value, page)
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

class BankSearchModal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    hideModal: PropTypes.func,
    banks: PropTypes.array,
    branches: PropTypes.array,
    count: PropTypes.number,
    currentPage: PropTypes.number,
    handleBankSearch: PropTypes.func,
    handleBranchSearch: PropTypes.func,
    onBankSelect: PropTypes.func,
    onReset: PropTypes.func,
    onSelect: PropTypes.func
  }

  render() {
    const {
      isOpen,
      hideModal,
      selectedBank,
      banks,
      branches,
      count,
      currentPage,
      handleBankSearch,
      handleBranchSearch,
      onBankSelect,
      onReset,
      onSelect,
      onHide
    } = this.props
    const headerLabel = selectedBank === null ? 'Search for bank code' : `Search for branch code (${selectedBank.name})`

    return (
      <CommonModal
        isOpen={isOpen}
        hideModal={hideModal}
        closeOnClick={true}
        onModalShow={handleBankSearch}
        onModalHide={onHide}
        ariaHideApp={false}>
        <CommonModal.Header hideModal={hideModal}>{headerLabel}</CommonModal.Header>
        <CommonModal.Body style={{ overflow: 'initial', padding: 0 }}>
          <BankSearch
            selectedBank={selectedBank}
            banks={banks}
            branches={branches}
            count={count}
            currentPage={currentPage}
            handleBankSearch={handleBankSearch}
            handleBranchSearch={handleBranchSearch}
            onReset={onReset}
            onBankSelect={onBankSelect}
            onSelect={onSelect}
          />
        </CommonModal.Body>
      </CommonModal>
    )
  }
}

export default BankSearchModal